import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { ReactElement } from 'react';
import { Loader } from '@sc/shared-ui';
import { fiveTickScale } from '../utility/chartScale';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface Props {
  name: string;
  loading: boolean;
  data: Array<{ label: string; count: number }>;
}

export const Graph = ({ name, loading, data }: Props): ReactElement => {
  const scale = fiveTickScale(data.map((d) => d.count));

  return (
    <div className="p-5 rounded-md flex flex-col">
      <div className="flex items-center mb-5 space-x-5">
        <h4 className="text-h2 font-grotesque font-semibold">{name}</h4>
        {loading && <Loader className="size-5" />}
      </div>
      <div className="h-48 w-full">
        <Bar
          options={{
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false,
              },
            },
            scales: {
              x: {
                grid: {
                  display: false,
                },
                ticks: {
                  color: '#879099',
                  font: {
                    size: 14,
                    family: 'Open Sans',
                  },
                },
              },
              y: {
                beginAtZero: true,
                max: scale.max,
                grid: {
                  color: '#292A2F',
                },
                border: {
                  display: false,
                },
                ticks: {
                  stepSize: scale.stepSize,
                  color: '#879099',
                  font: {
                    size: 14,
                    family: 'Open Sans',
                  },
                },
              },
            },
          }}
          data={{
            labels: data.map((d) => d.label),
            datasets: [
              {
                barThickness: 16,
                borderRadius: 2,
                label: name,
                data: data.map((d) => d.count),
                backgroundColor: '#70808E',
              },
            ],
          }}
        />
      </div>
    </div>
  );
};
